/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import FadeIn from "../../common/FadeIn";
//Bootstrap
import { Form, Col, Row, Button } from "react-bootstrap";
//Images and Icons
import { MdEmail } from "react-icons/md";

const CustomerChangeEmail = (props) => {
  const initialEmail = props.customer.email;
  const [email, setEmail] = useState(initialEmail);
  const [emailConfirm, setEmailConfirm] = useState(initialEmail);
  const currentKey = props.updateKey;

  const handleSubmit = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);

    if (email !== initialEmail && email === emailConfirm) {
      const newEmailRequest = await axios.put(
        `/api/customer/manage_customer/change_email_address`,
        { newEmail: email },
        {
          withCredentials: true,
        }
      );
      if (newEmailRequest.status === 200) {
        props.setViewMode("view");
        props.setSubmitClicked(false);
        return props.setUpdateKey(currentKey + 1);
      } else {
        props.setSubmitClicked(false);
        return props.setErrorMessage("There was an error - please contact support if it");
      }
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage(
        "Your email hasn't changed, or your confirm field and email field do not match."
      );
    }
  };

  return (
    <FadeIn delay={250} duration={450}>
      <Row className='mt-3'>
        <Col>
        <div className='shadow p-4 mx-auto'>
          <Form className='post' onSubmit={handleSubmit}>
            <Form.Group controlId='LessonTitleForm'>
              <Form.Label>New Email Address</Form.Label>
              <Form.Control
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                required
                type='email'
                className='border'
              />
            </Form.Group>
            <Form.Group controlId='LessonTitleForm' className='mt-3'>
              <Form.Label>Confirm New Email Address</Form.Label>
              <Form.Control
                defaultValue={emailConfirm}
                onChange={(e) => setEmailConfirm(e.target.value.toLowerCase())}
                required
                type='email'
                className='border'
              />
            </Form.Group>
            <Col sm='12' className='text-center mt-2 mb-2'>
              {props.submitClicked || props.errorMessage !== "" ? (
                <Button variant='info' className='w-100' type='submit'>
                  Processing...
                </Button>
              ) : (
                <Button variant='success' className='w-100' type='submit'>
                  Change Email <MdEmail />
                </Button>
              )}
            </Col>
          </Form>
          </div>
        </Col>
      </Row>
    </FadeIn>
  );
};

export default CustomerChangeEmail;
